export class CurrentUser {
  static GetToken() {
    if (localStorage.getItem("Token")) {
      let tokenData = JSON.parse(localStorage.getItem("Token"));
      let token =
        typeof tokenData.token === "string"
          ? JSON.parse(tokenData.token)
          : tokenData.token;

      if (token && token.access_token) {
        return token;
      }

      console.log("Token not found");
    }
    return null;
  }

  static ReplaceToken(access_token, refresh_token) {
    if (localStorage.getItem("Token")) {
      let tokenData = JSON.parse(localStorage.getItem("Token"));
      let token =
        typeof tokenData.token === "string"
          ? JSON.parse(tokenData.token)
          : tokenData.token;

      if (token && token.access_token) {
        token.access_token = access_token;
        token.refresh_token = refresh_token;
        tokenData.token = token;
        localStorage.setItem("Token", JSON.stringify(tokenData));
        return true;
      }
    }
    return false;
  }

  static GetCurrentUserData() {
    if (localStorage.getItem("Token")) {
      let tokenData = JSON.parse(localStorage.getItem("Token"));
      //console.log("Token stored in local storage");
      let udata =
        typeof tokenData.userData === "string"
          ? JSON.parse(tokenData.userData)
          : tokenData.userData;
      if (udata.length > 0 || (udata && udata.userId)) {
        return Array.isArray(udata) ? udata[0] : udata;
      }
    }
  }  
}
